export default __webpack_public_path__ + "static/icon-tile-light-b833d13f2b2103968a4980103b552efc.png";